module.exports = __webpack_public_path__ + "img/onHold-downArrow.381d1038.svg";